import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageComponent } from './chat-components/messages/message/message.component';
import { BalanceMessageComponent } from './chat-components/messages/balance-message/balance-message.component';
import { MarkSolvedMessageComponent } from './chat-components/messages/mark-solved-message/mark-solved-message.component';
import { SubscribeMessageComponent } from './chat-components/messages/subscribe-message/subscribe-message.component';
import { RateModalComponent } from './chat-components/modals/rate-modal/rate-modal.component';
import { ThankModalComponent } from './chat-components/modals/tips/thank-modal/thank-modal.component';
import { TipsModalComponent } from './chat-components/modals/tips/tips-modal/tips-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProgressBarComponent } from './chat-components/progress-bar/progress-bar.component';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChatRoutingModule } from './chat-routing.module';
import { WhatWrongModalComponent } from './chat-components/modals/feedback/what-wrong-modal/what-wrong-modal.component';
import { WrongFeedbackModalComponent } from './chat-components/modals/feedback/wrong-feedback-modal/wrong-feedback-modal.component';
import { ThankForFeedbackModalComponent } from './chat-components/modals/feedback/thank-for-feedback-modal/thank-for-feedback-modal.component';
import { LightboxModule } from 'ngx-lightbox';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { MultiChatComponent } from './multi-chat/multi-chat.component';
import { MultiChatDisplayComponent } from './multi-chat/multi-chat-display/multi-chat-display.component';
import { MultiChatNavigationComponent } from './multi-chat/multi-chat-navigation/multi-chat-navigation.component';
import { MultiChatClearComponent } from './multi-chat/multi-chat-clear/multi-chat-clear.component';
import { MultiChatNavigationCardComponent } from './multi-chat/multi-chat-navigation/multi-chat-navigation-card/multi-chat-navigation-card.component';
import { NavLayoutComponentModule } from '../../layouts/nav-layout/nav-layout-component.module';
import { NewTaskMessageComponentModule } from './chat-components/messages/new-task-message/new-task-message-component.module';

@NgModule({
  declarations: [
    MessageComponent,
    BalanceMessageComponent,
    MarkSolvedMessageComponent,
    SubscribeMessageComponent,

    RateModalComponent,
    ThankModalComponent,
    TipsModalComponent,
    WhatWrongModalComponent,
    WrongFeedbackModalComponent,
    ThankForFeedbackModalComponent,

    ProgressBarComponent,
    MultiChatComponent,
    MultiChatDisplayComponent,
    MultiChatNavigationComponent,
    MultiChatClearComponent,
    MultiChatNavigationCardComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgxSpinnerModule,
    ChatRoutingModule,
    NavLayoutComponentModule,
    FormsModule,
    LightboxModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300,
    }),
    NewTaskMessageComponentModule,
  ],
})
export class ChatModule {}
